import React from "react";
import "./Service.css";

function Service() {
  return (
    <div className="service component__space" id="Services">
      <div className="heading">
        <h1 className="heading">My Awesome Services</h1>
        <p className="heading p__color">
          There are more available services that I provide...
        </p>
        <p className="heading p__color">These are major ones!.</p>
      </div>
      <div className="container">
        <div className="row">
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path>
                  <line x1="2" y1="20" x2="2" y2="20"></line>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="service__text">Web Application Development</h1>
                <p className="service__text p__color">
                  Web applications are more complex than static websites, often
                  involving user registration, data processing, and interactive
                  features. As a web developer, I build dynamic web applications
                  that perform specific tasks, such as customer portals, online
                  booking systems, or project management tools.
                </p>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <polygon points="12 2 2 7 12 12 22 7 12 2"></polygon>
                  <polyline points="2 17 12 22 22 17"></polyline>
                  <polyline points="2 12 12 17 22 12"></polyline>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="service__text">
                  API Development and Integration
                </h1>
                <p className="service__text p__color">
                  APIs facilitate data exchange and integration between
                  different systems or services. As a web developer, I can
                  design and build APIs that allow seamless communication and
                  interaction between various applications. This service
                  involves developing RESTful or GraphQL APIs.
                </p>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="service__text">E-commerce Solutions</h1>
                <p className="service__text p__color">
                  I play a vital role in creating secure and user-friendly
                  online stores. By incorporating e-commerce functionalities
                  such as shopping carts, payment gateways, product catalogs,
                  and inventory management systems, I enable businesses to sell
                  products and services online effectively. This involves
                  integrating
                </p>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="service__text">
                  Website Maintenance and Support
                </h1>
                <p className="service__text p__color">
                  Websites require ongoing maintenance to ensure they run
                  smoothly and remain secure. As a web developer, I can offer
                  maintenance and support services, which include regularly
                  updating CMS platforms, plugins, and security patches. This
                  service also involves monitoring website performance.
                </p>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                  <circle cx="9" cy="7" r="4"></circle>
                  <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                  <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="service__text">Mobile App Development:</h1>
                <p className="service__text p__color">
                  In addition to web development, I can offer mobile app
                  development services. Using technologies like React Native I
                  can build cross-platform mobile applications for iOS and
                  Android platforms. This service involves designing and
                  developing mobile app interfaces, integrating with backend
                  APIs.
                </p>
              </div>
            </div>
          </div>
          <div className="col__3">
            <div className="service__box pointer">
              <div className="icon">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="2"
                  viewBox="0 0 24 24"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect>
                  <line x1="8" y1="21" x2="16" y2="21"></line>
                  <line x1="12" y1="17" x2="12" y2="21"></line>
                </svg>
              </div>
              <div className="service__meta">
                <h1 className="service__text">UI/UX Design</h1>
                <p className="service__text p__color">
                  Collaborating with designers, I can create visually appealing
                  and user-friendly interfaces that enhance the overall user
                  experience. I translate design concepts into functional
                  front-end code, ensuring intuitive navigation, responsive
                  layouts, and interactive elements.This aims to deliver a user
                  interface. This aims to deliver a user interface
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Service;
